import { Injectable } from "@angular/core";
import swal from "sweetalert2";
declare var $: any;

@Injectable({
    providedIn: 'root'
  })
export class Msg{

  private runCallback(callback: any, value?: any): void {
    if (typeof callback === 'function') {
      callback(value);
    }
  }

  //GENERICO DE MENSAJES BY ISAAC
    successCall(msg: string, titulo: string, callback: any){
        const title = titulo == null ?'Exitoso' : titulo 
        swal.fire({
            title: title,
            text: msg,
            buttonsStyling: false,
            customClass:{
              confirmButton: 'btn btn-success',
            },
            confirmButtonText: 'Aceptar',
            icon: 'success'
          }).then(callback);
    }

    warningCall(msg: string, titulo: string, callback: any){
       // const title = titulo == null ?'Oops...' : titulo 
        swal.fire({
            title: titulo,
            text: msg,
            buttonsStyling: false,
            customClass:{
              confirmButton: 'btn btn-info',
            },
            
            confirmButtonText: 'Aceptar',
            icon: 'warning'
          }).then(callback);
        
    }

    errorCall(msg: string, titulo: string, callback: any){
        const title = titulo == null ?'Error' : titulo
        swal.fire({
            title: title,
            text: msg,
            buttonsStyling: false,
        
            customClass:{
              confirmButton: 'btn btn-error',
            },
            confirmButtonText: 'Aceptar',
            icon: 'error'
          }).then(callback);
    }

    infoCall(msg: string, titulo: string, callback: any){
        const title = titulo == null ?'Oops...' : titulo 
        swal.fire({
            title: title,
            text: msg,
            buttonsStyling: false,
            customClass:{
              confirmButton: 'btn btn-info',
            },
            confirmButtonText: 'Aceptar',
            icon: 'info'
          }).then((result) => this.runCallback(callback, result));
    }

    questionCall(msg: string, titulo: string, callback: any){

      swal.fire({
        title: '¿Estás seguro?',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3f9142',
        cancelButtonColor: '#f44336',
        
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => this.runCallback(callback, result))
    }

    inputCall(msg: string, titulo: string, callback: any){

    }
    showSuccessNotification(fromVAlign: string, mensaje: string){
      this.showNotification(fromVAlign,'check','success','¡EXITO!',mensaje);
    }
    showErrorNotification(fromVAlign: string, mensaje: string){
      this.showNotification(fromVAlign,'error_outline','primary','¡ERROR!',mensaje);
    }
    showInfoNotification(fromVAlign: string, mensaje: string){
      this.showNotification(fromVAlign,'error','rose','¡INFO!',mensaje);
    }
    showWarningNotification(fromVAlign: string, mensaje: string){
      this.showNotification(fromVAlign,'warning','warning','¡ALERTA!',mensaje);
    }

    showNotification(from: any, icon: any, type:any,titulo:any, mensaje:any) {
      $.notify({
          icon: icon,
          message: mensaje,
          title: titulo,
      }, {
          type: type,
          timer: 3000,
          // El topbar es fixed (68px, --solser-topbar-height) con z-index por encima
          // del toast, asi que con el offset default (20px) la notificacion queda
          // detras del navbar. Se usa la misma holgura que el resto del layout:
          // alto del topbar + 12px.
          offset: {
              x: 20,
              y: 80
          },
          placement: {
              from: from,
              align: 'right'
          },
          template: '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0} alert-with-icon" role="alert">' +
         '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
         '<i class="material-icons" data-notify="icon">'+icon+'</i> ' +
         '<h5 data-notify="title" class="m-0 fw-semibold">{1}</h5> ' +
         '<span data-notify="message">{2}</span>' +
         '<div class="progress" data-notify="progressbar">' +
         '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          '</div>'
      });
  }
}
